


export enum UploaderFileTypes {
  medical = 'MEDICAL',
  hygiene = 'HYGIENE',
  other = 'OTHER'
}
